import * as gxConst from "@/api/http/gx/gxConst";
import * as gxRequest from "@/api/http/gx/gxBase";
import { getUUid } from "@/api/http/utils/apiHelpers";

import { creatUUid } from "@/api/http/utils/apiHelpers";
import {sendGXError, sendGXSuccess} from "@/utils/analytics";

export const getFeedByUserId = (
  userId: any,
  feedType: any = "all",
  effectUserSize: any
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = userId ? userId : await getUUid();
      const params: any = {};
      // if (feedType) {
      //   params.kind = feedType;
      //   params.need_all = false;
      // } else {
      //   params.kind = "all";
      //   params.need_all = true;
      //   params.allow_all_kind = true;
      // }
      params.kind = "all";
      params.need_all = true;
      params.allow_all_kind = true;

      params.active_account_count = effectUserSize;
      params.follow_account_count = effectUserSize;
      params.like_account_count = effectUserSize;
      params.comment_account_count = effectUserSize;
      params.auto_mode = false;
      const result = await gxRequest.get(
        gxConst.kGetXApiPathGetFeed(uid),
        params
      );
      sendGXSuccess("getFeedByUserId");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'getFeedByUserId');
      reject(error);
    }
  });
};

export const actFeed = (
  masterId: any,
  userId: any,
  status: any,
  message: any,
  feedKind: any,
  resourceId: any,
  isSilent: boolean = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const userInfo = {
        master_id: masterId,
        user_id: userId
      };
      const params: any = {};
      params.user_info = userInfo;
      params.result_body = { status, message };
      params.kind = feedKind;
      params.resource_id = resourceId;
      params.transaction_id = creatUUid(); //此次交易的唯一ID (随机UUID)
      params.is_silent = isSilent;
      const result = await gxRequest.post(
        gxConst.kGetXApiPathFeedAct(resourceId),
        params
      );
      sendGXSuccess("actFeed");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'actFeed');
      reject(error);
    }
  });
};

export const blockFeed = (feedId: any, kind: any, message: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const params = {
        feed_id: feedId,
        kind,
        message
      };
      const res = await gxRequest.post(gxConst.kGetXApiPathFeedBlock, params);
      sendGXSuccess("blockFeed");
      resolve(res);
    } catch (error) {
      sendGXError(error, 'blockFeed');
      reject(error);
    }
  });
};
